// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningRecordId } from './CleaningRecord';
import { cleaningFieldId } from './CleaningField';
import { calendarDate } from '../../calendar-date';
import { invItemId } from './InvItem';
import { cpLevelEnum } from './CpLevelEnum';
import { z } from 'zod';
export const cleaningRecordValueId = (z.number());
export const cleaningRecordValue = z.object({
    id: cleaningRecordValueId,
    record_id: cleaningRecordId,
    field_id: cleaningFieldId,
    number_value: z.string().nullable(),
    number_unit: z.string().nullable(),
    text_value: z.string().nullable(),
    checkbox_value: z.boolean().nullable(),
    datetime_value: z.date().nullable(),
    date_value: calendarDate.nullable(),
    inventory_item_id: invItemId.nullable(),
    computed_formula_used: z.string().nullable(),
    computed_from_values: z.unknown().nullable(),
    computation_error: z.string().nullable(),
    note: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    cp_level: cpLevelEnum.nullable(),
    cp_details: z.string().nullable(),
    cp_number_target: z.string().nullable(),
    cp_number_abs_tol_lower: z.string().nullable(),
    cp_number_abs_tol_upper: z.string().nullable(),
    cp_number_rel_tol_lower: z.string().nullable(),
    cp_number_rel_tol_upper: z.string().nullable(),
    cp_number_unit: z.string().nullable(),
    cp_check_value: z.boolean().nullable(),
});
export const cleaningRecordValueInitializer = z.object({
    id: cleaningRecordValueId.optional(),
    record_id: cleaningRecordId,
    field_id: cleaningFieldId,
    number_value: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    text_value: z.string().optional().nullable(),
    checkbox_value: z.boolean().optional().nullable(),
    datetime_value: z.date().optional().nullable(),
    date_value: calendarDate.optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    computed_formula_used: z.string().optional().nullable(),
    computed_from_values: z.unknown().optional().nullable(),
    computation_error: z.string().optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    cp_level: cpLevelEnum.optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_number_target: z.string().optional().nullable(),
    cp_number_abs_tol_lower: z.string().optional().nullable(),
    cp_number_abs_tol_upper: z.string().optional().nullable(),
    cp_number_rel_tol_lower: z.string().optional().nullable(),
    cp_number_rel_tol_upper: z.string().optional().nullable(),
    cp_number_unit: z.string().optional().nullable(),
    cp_check_value: z.boolean().optional().nullable(),
});
export const cleaningRecordValueMutator = z.object({
    id: cleaningRecordValueId.optional(),
    record_id: cleaningRecordId.optional(),
    field_id: cleaningFieldId.optional(),
    number_value: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    text_value: z.string().optional().nullable(),
    checkbox_value: z.boolean().optional().nullable(),
    datetime_value: z.date().optional().nullable(),
    date_value: calendarDate.optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    computed_formula_used: z.string().optional().nullable(),
    computed_from_values: z.unknown().optional().nullable(),
    computation_error: z.string().optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    cp_level: cpLevelEnum.optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_number_target: z.string().optional().nullable(),
    cp_number_abs_tol_lower: z.string().optional().nullable(),
    cp_number_abs_tol_upper: z.string().optional().nullable(),
    cp_number_rel_tol_lower: z.string().optional().nullable(),
    cp_number_rel_tol_upper: z.string().optional().nullable(),
    cp_number_unit: z.string().optional().nullable(),
    cp_check_value: z.boolean().optional().nullable(),
});
//# sourceMappingURL=CleaningRecordValue.js.map